import { FunctionComponent } from "react";

export const ItzehoerLogo: FunctionComponent = () => {
  return (
    <img
      src="/images/brand/itzehoer.svg"
      className={"w-32 md:w-[161px] max-h-[40px] object-contain"}
      alt="Itzehoer"
    />
  );
};
